
// client/src/App.jsx
import React, { useEffect }  from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import About from './pages/About';
import Checkout from './pages/Checkout';
import Rooms from './pages/Rooms';
import AdminAddRoom from './pages/AdminAddRoom';
import AdminBlockRoom from './pages/AdminBlockRoomDates';
import AdminRooms from './pages/AdminRooms';
import Home from './pages/Home';
import Terms from './pages/Terms';
import { BookingProvider } from './context/BookingContext';
import BookingRoutes from './pages/BookingRoutes';
import AdminDashboard from './pages/AdminDashboard';



// A simple protected route component
const PrivateRoute = ({ children }) => {
  const { user } = React.useContext(AuthContext);
  return user ? children : <Navigate to="/admin/login" />;
};

function App() {

   useEffect(() => {
    fetch('https://casagloriabackend.onrender.com/api/health')
      .then(() => console.log('Backend awake'))
      .catch(err => console.log('Backend wakeup failed:', err));
  }, []);
  
  return (
    <AuthProvider>
      <BookingProvider>
        <Router>
          <Navbar />
          <div className="p-4">
            <Routes>
              <Route path="/terms" element={<Terms />} />
              <Route path="/" element={<Home />} />
              <Route path="/booking/*" element={<BookingRoutes />} />
              <Route path="/rooms" element={<Rooms />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/about" element={<About />} />
              
         {/* Admin routes */}
  <Route path="/admin/login" element={<Login />} />
  <Route
    path="/admin/dashboard"
    element={
      <PrivateRoute>
        <AdminDashboard />
      </PrivateRoute>
    }
  />
  <Route
    path="/adminrooms"
    element={
      <PrivateRoute>
        <AdminRooms />
      </PrivateRoute>
    }
  />
  <Route
    path="/adminaddroom"
    element={
      <PrivateRoute>
        <AdminAddRoom />
      </PrivateRoute>
    }
  />
  <Route
    path="/adminblockroom"
    element={
      <PrivateRoute>
        <AdminBlockRoom />
      </PrivateRoute>
    }
  />
            </Routes>
          </div>
        </Router>
      </BookingProvider>
    </AuthProvider>
  );
}

export default App;
